import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../../../../hooks/hooks";
import PageLoader from "../../../../../../components/PageLoader";
import Table from "../../../../../../common/components/table";
import { selectOpennetworkLogsListItems } from "../../../../../../redux/open-network-logs/selector";
import { opennetworkLogs } from "../../../../../../redux/open-network-logs/action";

const RejectionLogs = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10);
  const openNetworkLogsItems = useSelector(selectOpennetworkLogsListItems)
  const [columnDefs, setColumnDefs] = useState({});

  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      { field: 'context.transaction_id', headerName: 'Transaction Id', searchField: 'transaction_id', sortable: true, filter: true, filterType: 'text' },
      { field: 'context.bap_id', headerName: 'BAP Id', sortable: false, filter: true },
      { field: 'context.bpp_id', headerName: 'BPP Id', sortable: false, filter: true },
      { field: 'context.domain', headerName: 'Domain', sortable: false, filter: true },
      { field: 'context.city', headerName: 'City', sortable: false, filter: true },
      { field: 'context.timestamp', headerName: 'Timestamp', isDateValueFormat: true, sortable: false },
    ]);
  }

  const handleSearch = (data: any) => {
    let searchCriteria = {};
    if (data?.column) {
      searchCriteria = [{
        FieldName: data?.column,
        FieldText: data?.column,
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    } else {
      searchCriteria = [{
        FieldName: "Name",
        FieldText: "Name",
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    }
    dispatch(opennetworkLogs.list({
      url: `https://catalog.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/catalog/catalog-collections/rejections/fetch`,
      entity: 'opennetworkLogs',
      jsonData:
      {
        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",
        "Searches": searchCriteria,
      }
    }))
  }

  const handleReloadData = () => {
    fetchRejectionsLogsList();
  }

  const fetchRejectionsLogsList = () => {
    dispatch(opennetworkLogs.list({
      url: `https://catalog.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/catalog/catalog-collections/rejections/fetch`,
      entity: 'opennetworkLogs',
      jsonData:
      {
        "Pagination": {
          "PageNumber": pageData,
          "PageSize": pageSize,
          "SortField": "Id",
          "SortOrder": "desc",
        }
      }
    }))
  }

  const additionButtons: any = [
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
          <title>Reload</title>
          <path d="M20.0092 2V5.13219C20.0092 5.42605 19.6418 5.55908 19.4537 5.33333C17.6226 3.2875 14.9617 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
      callback: () => handleReloadData(),
    },
  ];

  useEffect(() => {
    createColumnDefs()
    fetchRejectionsLogsList()
  }, [pageData, pageSize])

  return (
    <>
      {openNetworkLogsItems?.isLoading ? <PageLoader /> :
        <Table columnData={columnDefs} rowData={openNetworkLogsItems?.result?.items}
          enableFilter={true} onSearch={handleSearch}
          setPageData={setPageData} paginationData={openNetworkLogsItems?.result?.pagination} setPageSize={setPageSize}
          additionButtons={additionButtons}
          headingName="Rejection Logs"
        />
      }
    </>
  );
};

export default RejectionLogs;


